import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export interface Position {
  _id: string;
  symbol: string;
  exchange: string;
  side: "LONG" | "SHORT";
  qty: number;
  avgPrice: number;
  ltp: number;
  pnl: number;
  pnlPct: number;
  invested: number;
  currentValue: number;
  mode: "REAL" | "VIRTUAL";
  strategy?: string;
  updatedAt: string;
}

interface PositionsResponse {
  data: Position[];
  total: number;
}

export function usePositions(mode?: "REAL" | "VIRTUAL") {
  const query = useQuery<PositionsResponse>({
    queryKey: ["positions", mode],
    queryFn: () =>
      api.get<PositionsResponse>(`/positions${mode ? `?mode=${mode}` : ""}`),
  });

  // Extract the array for convenience
  return {
    ...query,
    positions: query.data?.data ?? [],
  };
}

export function usePosition(id: string) {
  return useQuery<Position>({
    queryKey: ["positions", id],
    queryFn: () => api.get<Position>(`/positions/${id}`),
    enabled: !!id,
  });
}
